const apiBase =
  process.env.REACT_APP_ENV === 'staging'
    ? 'https://api.klimaberegneren.dk/staging_panel/api'
    : 'https://api.klimaberegneren.dk/api_panel/api';

const googleMapApiKey = process.env.REACT_APP_GOOGLE_API_KEY

// Deliberate cosmetic delays (ms) on the result-details page: the fake
// "reading the energy label" pause before the fetch, and the timed reveal of
// the sales-pitch buttons. Collapsed to 0 automatically under Jest, and in any
// environment that sets REACT_APP_DISABLE_UI_DELAYS=true (the Playwright e2e
// dev server does), so tests never wait on these timers.
const uiDelaysDisabled =
  process.env.NODE_ENV === 'test' ||
  process.env.REACT_APP_DISABLE_UI_DELAYS === 'true';

const uiDelays = {
  propertyDetailsFetch: uiDelaysDisabled ? 0 : 1000,
  salesPitchButton: uiDelaysDisabled ? 0 : 3000,
  mobileSalesPitchButton: uiDelaysDisabled ? 0 : 1650,
};

export { apiBase, googleMapApiKey, uiDelays };
